<template>
  <el-tooltip :content="toggleLabel" placement="bottom" :show-after="300">
    <span class="theme-toggle-control">
      <el-switch
        v-model="isDark"
        class="theme-toggle-switch"
        :active-action-icon="Moon"
        :inactive-action-icon="Sunny"
        :aria-label="toggleLabel"
        @change="handleThemeChange"
      />
    </span>
  </el-tooltip>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Moon, Sunny } from '@element-plus/icons-vue';
import {
  DARK_THEME,
  LIGHT_THEME,
  getThemeToggleLabel,
  isDarkTheme,
  readStoredTheme,
  setTheme,
} from '@/utils/theme.mjs';

const isDark = ref(isDarkTheme(readStoredTheme()));
const toggleLabel = computed(() => getThemeToggleLabel(isDark.value));

function handleThemeChange(checked) {
  const appliedTheme = setTheme(checked ? DARK_THEME : LIGHT_THEME);
  isDark.value = isDarkTheme(appliedTheme);
}
</script>

<style scoped>
.theme-toggle-control {
  width: 44px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.theme-toggle-switch {
  --el-switch-on-color: #2c2c2c;
  --el-switch-off-color: #f2f2f2;
}

.theme-toggle-switch :deep(.el-switch__core) {
  min-width: 40px;
  height: 20px;
  border-color: var(--wf-control-border, #dcdfe6);
}

.theme-toggle-switch :deep(.el-switch__action) {
  width: 14px;
  height: 14px;
  color: #606266;
}

.theme-toggle-switch :deep(.el-icon) {
  font-size: 12px;
}

:global(html.dark .theme-toggle-switch .el-switch__action) {
  color: #303133;
}
</style>
